export default function () {
  try {
    if (window.xr) {
      var recordings = Array.from(xr.global.recordingContexts.keys());

      if (recordings.length > 0) {
        var context = xr.global.recordingContexts.get(recordings[0]);

        if (context.appKey && context.recordingId && context.isRecording) {
          return {
            appKey: context.appKey,
            recordingId: context.recordingId
          };
        }
      }
    }
  } catch (ex) {}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker@1.0.34@@ali/aes-tracker/es/xreplay/index.js
// module id = null
// module chunks = 